/* eslint-disable */
import { Component } from 'react';
import { Container, Row, Col, FormGroup, Input, Button, Form, Alert } from 'reactstrap'

import { Utils, Http, API, Auth, Constant, withRouter, Images, NavLink, Trans } from 'Helpers'
//import CountDownCustom from "../../views/CountDownCustom";

import { ReduxHOC } from 'HOC';
import Moment from "react-moment";
import {HeaderModal} from 'Modals';
import { notifyParent } from 'Hooks/useNotifyParentOnRouteChange';



const md5 = require('md5');
class MobHeader extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      modalOpen:false
    }
  }

  sendMessageToParent = (event) => {
    window.parent.postMessage({ action: event }, '*');
  };

  checkDate = (inputDate) => {
    const now = new Date() && new Date();
    const enteredDate = new Date(inputDate);
    const differenceInHours = Math.abs(enteredDate - now) / (1000 * 60 * 60);
    const isSameDay = now.toDateString() === enteredDate.toDateString();
    const isWithin24Hours = differenceInHours <= 24;
    if (isSameDay || isWithin24Hours) {
        return "Today";
    } else {
        return "Tomorrow";
    }
};

goBack =()=>{
  if(this.props.backTo){
    this.props.history.push(this.props.backTo)
  } else {
    this.props.history.goBack()
  }
}

toggleDrawer =()=>{
  this.setState({
    modalOpen:!this.state.modalOpen
  })
}
 
  goToLearnPage = () => {
    notifyParent("PUSH", '/learn');
    this.props.history.push('/learn');
  }

  render() {
    
    const {  title, backTitleAction,drawerMenu, titleContest, backHandle, showHowToPlay, leftTitle, centerTitle } = this.props
    const {modalOpen} = this.state
    const HeaderModalProps ={
      isOpen:modalOpen,
      toggle:this.toggleDrawer
    }    
    
    return (
      <>
      <div className='mob-header'>
        <div className='mob-header-left'>
          {leftTitle && 
          <div className='title-header landing-page'>
        <span>{leftTitle}</span>
        </div>}
          {/* {backTitleAction && <a onClick={()=>this.sendMessageToParent('CLICKED_BACK_BUTTON')} className='back-title-action top-dta'><i className='icon-previous'/><i className='icon-previous'/>{backTitleAction}</a>} */}
          {backHandle && <a  className='back-title-action curved-btn' onClick={()=>this.goBack()}><span><i className='icon-previous'></i></span></a>}
        </div>
        {
       centerTitle && 
       <div className='title-header'>
         {centerTitle && <span>{centerTitle}</span>}     
        </div>
        }
       {!leftTitle  && !centerTitle &&
       <div className='title-header'>
         {title && <span>{title}</span>}
        {
          titleContest !=='' && <span>{titleContest.contest_name}</span>
        }
        {  titleContest !=='' && titleContest.league_name && 
        <div className='contest-detail-header'>
          <span className='leg-name'>
            {titleContest.league_name}
          </span>
          {/* {
            titleContest && 
            <span className='gw-lbl'>{Utils.getWeekLabel(Utils.getMultiLeg().week_abbr[titleContest.start_week])} {titleContest.start_week} - {titleContest.end_week}</span>
          } 
          <small className='pipe-sept'>|</small>
        {
        this.checkDate(titleContest.deadline_date) === "Today" ? (
            <div className="count-clock">

                 <CountDownCustom  targetDate={titleContest.deadline_date} /> 
            </div>
        ) : (
            <div className="schedule-date">
                <Moment
                    date={Utils.getUtcToLocal(titleContest.deadline_date)}
                    format="MMM DD - hh:mm"
                  />
            </div>
        )
        } */}
        
        </div>
        }
        
        </div>}
        
        <div className='mob-header-right'>
          {showHowToPlay && 
            <div className="how-to-play-learn" onClick={this.goToLearnPage}>
                          <Trans>How To Play?</Trans>
            </div>
          }
          {
          drawerMenu && 
            <img src={Images.DRAWER_NW} className="header-menu-icn" onClick={()=>this.toggleDrawer()} alt='' />
          }
        </div>
      </div>
      
      <HeaderModal {...HeaderModalProps}/>
      </>
    )
  }
}
MobHeader.defaultProps = {

}
const MobHeaderWraped = withRouter(ReduxHOC(MobHeader));

export default MobHeaderWraped;


